import { BoxDetailsEntity } from "@modules/box/entities/boxEntity"
import { type WebBoxInputDto } from "@modules/box/services/boxDto"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useCreateBox = () => {
  const { boxApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: createBox, isPending } = useMutation({
    mutationFn: async (box: WebBoxInputDto) => {
      return await boxApi.createBox(box)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["boxs"] })

      return BoxDetailsEntity.fromDto(data)
    },
  })

  return { createBox, isPending }
}

export const useUpdateBox = () => {
  const { boxApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: updateBox, isPending } = useMutation({
    mutationFn: async ({ boxId, box }: { boxId: string; box: WebBoxInputDto }) => {
      return await boxApi.updateBox(boxId, box)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["boxs"] })
      queryClient.setQueryData(["box", data.id], BoxDetailsEntity.fromDto(data))

      return BoxDetailsEntity.fromDto(data)
    },
  })

  return { updateBox, isPending }
}

export const useDeleteBox = () => {
  const { boxApi /*, currentSpaceManager*/ } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteBox, isPending } = useMutation({
    mutationFn: async ({ boxId }: { boxId: string }) => {
      await boxApi.deleteBox(boxId)
      return boxId
    },
    onSuccess: (boxId) => {
      queryClient.invalidateQueries({ queryKey: ["boxs"] })
      queryClient.removeQueries({ queryKey: ["box", boxId] })

      // if (currentSpaceManager.currentBox?.boxId === boxId) {
      //   currentSpaceManager.setCurrentBox(null)
      // }
    },
  })

  return { deleteBox, isPending }
}
